import { OrderWarnings, type Order } from '@talos/kyoko';

export function renderOrderWarningDetails(data: Order) {
  return data.warning == null ? null : <OrderWarnings warning={data.warning} variant="mobileDetail" />;
}
